import React, { useEffect, useState } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';
// import Store from './redux/store';
import { ConfigProvider } from 'antd';
// import NotFound from './pages/notFound';
import './App.css';
// import './src/styles/variables/_colors.scss';
import { useRedux } from './redux/useRedux';
import Auth from './page/auth/index';
import Dashboard from './page/dashboard/index';
import LN from 'utils/language';
import { onChangePublic } from 'redux/actions/public';
import PublicReducer from './redux/reducers/publicReducer';
import { AuthProvider } from './contexts/auth-context';
import AppRoutes from './routes/AppRoutes';

const App = () => {
  // const store = Store();
  const { publicState } = useRedux()
  // console.log(publicState)
  const [cleanCash, setCleanCash] = useState(false)
  useEffect(() => {
    // alert(publicState)
    localStorage.setItem("direction", publicState?.direction)
    LN.setLanguage(publicState?.direction === 'rtl' ? 'en' : 'fa');
    setTimeout(() => {
      setCleanCash(!cleanCash)
    }, 50)
    LN.setLanguage(publicState?.direction === 'rtl' ? 'fa' : 'en');
    // store.dispatch(onChangePublic("direction",'rtl'))
    document.documentElement.style.setProperty("--dir", publicState?.direction === 'rtl' ? 'rtl' : 'ltr')
    // document.documentElement.style.setProperty("--windowWidth",window.innerWidth)
  }, [publicState?.direction])

  return (


    <ConfigProvider
      // direction="var(--dir)"
      // direction={"ltr"}
      componentSize={"large"}
      direction={publicState?.direction}
      theme={{
        components: {
          Segmented: {
            itemSelectedBg:"#000",
          },
          Select: {
            // colorBgElevated:"#000",
            // colorBgContainer:"#000",
            // controlItemBgHover:"#000",
            // controlItemBgActive:"#000",
            // colorText:"#fff",
          },
        },
      }}
    >
      <AuthProvider>

        {/* {cleanCash} */}
        <BrowserRouter>
          <AppRoutes />

        </BrowserRouter>
      </AuthProvider>
    </ConfigProvider>

  );
};

export default App;
